import { ComponentProps } from "react";
import { Description } from "@radix-ui/react-dialog";
import { cn } from "@/utils/cn";

export const SheetDescription = ({
    className,
    ...props
}: ComponentProps<typeof Description>) => {
    return (
        <Description
            data-slot="sheet-description"
            className={cn("text-muted-foreground text-sm", className)}
            {...props}
        />
    )
}